




































import {Vue, Component} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import PageHeader from '@/components/PageHeader.vue'
import DialogFooter from '@/components/DialogFooter.vue'

const auth = namespace('auth')
const certificates = namespace('certificates')

@Component({
  components: {
    PageHeader,
    DialogFooter,
  },
})
export default class UserAccount extends Vue {
  @auth.Action('signOut') signOut
  @auth.Action('deleteUser') deleteUser

  @certificates.Mutation('clear') clearCertificates

  openDeleteAccount: boolean = false

  back() {
    this.$router.back()
  }

  onLogout() {
    this.signOut()
    this.$router
      .push({name: 'sign-in'})
      .catch((err) => err)
  }

  onDeleteAccount() {
    this.deleteUser().then(() => {
      this.openDeleteAccount = false
      this.clearCertificates()
      this.onLogout()
    })
  }
}
